import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import { API_URL } from '../../constant';
import './CaptainTCCard.css';
import captainTcImg from '../../images/captain-tc/captain-tc-card.jpeg';

function CaptainTCCard() {
    const outletContext = useOutletContext() || {};
    const { userData } = outletContext;

    const [loading, setLoading] = useState(true);
    const [cards, setCards] = useState([
        { tier: '£5', price: '£ 5.00', purchased: false, serial: null },
        { tier: '£10', price: '£ 10.00', purchased: false, serial: null },
        { tier: '£25', price: '£ 25.00', purchased: false, serial: null },
    ]);

    const getAuthHeaders = useCallback(() => {
        const token = localStorage.getItem('auth_token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        };
    }, []);

    const fetchCardStatus = useCallback(async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            if (!token) return;

            const response = await fetch(`${API_URL}/api/customer/captain-tc-cards`, {
                headers: getAuthHeaders(),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success && data.cards) {
                    setCards(prev => prev.map(card => {
                        const apiCard = data.cards.find(c =>
                            c.tier === card.tier || c.price === card.price
                        );
                        if (apiCard) {
                            return {
                                ...card,
                                purchased: apiCard.purchased || false,
                                serial: apiCard.serial || null,
                            };
                        }
                        return card;
                    }));
                }
            }
        } catch (err) {
            console.warn('Captain TC Cards API not available:', err.message);
        } finally {
            setLoading(false);
        }
    }, [getAuthHeaders]);

    useEffect(() => {
        fetchCardStatus();
    }, [fetchCardStatus]);

    const tierColors = {
        '£5': { accent: '#cd7f32', gradient: 'linear-gradient(135deg, #cd7f32, #a0622e)', label: 'Bronze' },
        '£10': { accent: '#C0C0C0', gradient: 'linear-gradient(135deg, #C0C0C0, #a8a8a8)', label: 'Silver' },
        '£25': { accent: '#FFD700', gradient: 'linear-gradient(135deg, #FFD700, #daa520)', label: 'Gold' },
    };

    if (loading) {
        return (
            <div className="captain-tc-wrapper">
                <div className="captain-tc-loading">
                    <div className="captain-tc-spinner"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="captain-tc-wrapper">
            {/* Header */}
            <div className="captain-tc-header">
                <div className="captain-tc-header-left">
                    <span className="captain-tc-label">Captain TC</span>
                    <h2 className="captain-tc-title">Cash-Wallet Card</h2>
                </div>
                <div className="captain-tc-header-right">
                    <img
                        src={captainTcImg}
                        alt="Captain TC Card"
                        className="captain-tc-thumb"
                    />
                </div>
            </div>

            {/* Card Tiers */}
            <div className="captain-tc-cards-grid">
                {cards.map((card) => {
                    const colors = tierColors[card.tier];
                    return (
                        <div
                            key={card.tier}
                            className={`captain-tc-card-item ${card.purchased ? 'purchased' : 'not-purchased'}`}
                        >
                            <div
                                className="captain-tc-card-accent"
                                style={{ background: colors.gradient }}
                            ></div>

                            <div className="captain-tc-card-body">
                                <div className="captain-tc-card-price-row">
                                    <span
                                        className="captain-tc-card-price"
                                        style={{ color: colors.accent }}
                                    >
                                        {card.price}
                                    </span>
                                    <span
                                        className={`captain-tc-purchase-badge ${card.purchased ? 'badge-yes' : 'badge-no'}`}
                                    >
                                        {card.purchased ? '✓ Purchased' : 'Not Purchased'}
                                    </span>
                                </div>

                                <div className="captain-tc-card-tier-label">
                                    {colors.label} Card
                                </div>

                                {card.purchased && card.serial && (
                                    <div className="captain-tc-serial">
                                        Serial: <strong>{card.serial}</strong>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CaptainTCCard;
